<template>
  <el-dialog
    :title="name"
    :visible.sync="visible"
    width="470px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    custom-class="detail-modal"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="68px"
      class="demo-ruleForm"
    >
      <el-form-item label="文件夹：" prop="folderId">
        <el-cascader
          clearable
          v-model="ruleForm.folderId"
          :options="folder"
          :props="{
            value: 'id',
            label: 'name',
            children: 'children',
            checkStrictly: true,
          }"
          style="width: 100%"
        ></el-cascader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="handleOk('ruleForm')" v-loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getMaterialFetch, copyFilesFetch, moveFilesFetch } from "../../api/material";
export default {
  data() {
    return {
      visible: false,
      name: "",
      folderId: null,
      fileName: null,
      loading: false,
      ruleForm: {
        folderId: null,
      },
      folder: [],
      rules: {
        folderId: [
          {
            type: "array",
            required: true,
            message: "请选择文件夹",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    handleClose(formName) {
      this.visible = false;
      this.$refs[formName].resetFields();
      this.$emit("clearOptionValue");
    },
    showModal(name, folderId, uuids) {
      this.visible = true;
      this.name = name;
      this.folderId = folderId;
      this.fileName = uuids;

      getMaterialFetch().then((res) => {
        this.folder = res.data;
      });
    },
    handleOk(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.name == "移动素材") {
            moveFilesFetch({
              toFolderId: this.ruleForm.folderId[this.ruleForm.folderId.length - 1],
              fromFolderId: this.folderId,
              fileNames: this.fileName.join(","),
            })
              .then((res) => {
                if (res.code == "0000") {
                  this.$message.success("移动成功");
                  this.$emit("updateTags", this.folderId);
                  this.visible = false;
                  this.loading = false;
                } else {
                  this.loading = false;
                }
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            copyFilesFetch({
              toFolderId: this.ruleForm.folderId[this.ruleForm.folderId.length - 1],
              fromFolderId: this.folderId,
              fileNames: this.fileName.join(","),
            })
              .then((res) => {
                if (res.code == "0000") {
                  this.$message.success("复制成功");
                  this.$emit("updateTags", this.folderId);
                  this.visible = false;
                  this.loading = false;
                } else {
                  this.loading = false;
                }
              })
              .catch(() => {
                this.loading = false;
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less">
.demo-ruleForm {
  .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
